
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { labAs400Service } from './labAs400Service';




const create = async (tokenAtencion, modalidad) => {

  
  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null;
  }

  const query = `
    mutation CreateEstudioLab(
      $tokenAtencion: String!
      $modalidad: String! 
    ) {
      createEstudioLab(
        tokenAtencion: $tokenAtencion, 
        modalidad: $modalidad
      ) {
        message
        status
        estlab {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenAtencion: tokenAtencion,
    modalidad    : modalidad || 1
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.createEstudioLab;
    const data = response2.estlab;
    return data;
    
  }catch(error){
    console.error("Error al crear estudio laboratorio:", error);
  }
}


const updateNumeroOrden = async ( idExamenLaboratorio, newNumberOrden ) => {
  const query = `
    mutation MyMutation($idExamenLaboratorio: ID!, $newNumberOrden: Int!) {
      updateNumeroOrden(idExamenLaboratorio: $idExamenLaboratorio, newNumberOrden: $newNumberOrden) {
        message
        status
      }
    }
  `;
  const variables = { 
    idExamenLaboratorio: idExamenLaboratorio, 
    newNumberOrden     : newNumberOrden 
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    
    return response;
  }catch( error ){
    console.error( error );
    return error;
  }
}



const updateById = (  ) => {
  console.log('update is not implemented yet');
}


const updateMspFiles = async ( idEstLaboratorio, archivosMsp ) => {
  const query = `
    mutation updateMspFiles(
      $idEstLaboratorio  : ID!, 
      $archivoPaciente: String!
      $archivoTitular1: String
      $archivoTitular2: String
    ) {
      actualizarLabAS400Califica(
        id: $idEstLaboratorio, 
        urlMspCalificacion: $archivoPaciente,
        urlMspCalificacion1: $archivoTitular1
        urlMspCalificacion2: $archivoTitular2
      ) {
        message
        status
      }
    }
  `;
  const variables = {
    idEstLaboratorio: idEstLaboratorio,
    archivoPaciente : archivosMsp.paciente,
    archivoTitular1 : archivosMsp.titular1,
    archivoTitular2 : archivosMsp.titular2,
  };
  
  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    
    return response;

  }catch(error){
    console.error(error);
    return error;
  }
}


const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        status
        message
        atcm {
          id
          token
          estudiolabSet {
            id
            token
            modalidad {
              id, descripcion
            }
            LabAs400 {
              id
              token
              numeroOrden
              justificacion
              fechaOrdenOrion
              idslaboratorios
              estado
            }
            LabAux {
              token
              id
              estadoHomologado
              laboratorios
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    const response2 = response.data.data.allAtenmedica;
    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;
    if( response2.atcm[0].estudiolabSet.length === 0 ) return null;

    const data          = response2.atcm[0].estudiolabSet[0];

    const idEstudioLab  = data.id;
    const labsAs400     = data.LabAs400;
    const labsAuxiliar  = data.LabAux;

    if( !labsAs400 && !labsAuxiliar ) return null;

    const labsAs400Activos = labsAs400.filter( lab => lab.estado === '1')

    const labsAs400Map = await Promise.all(labsAs400Activos.map( async (lab) => {

      const examenesIdArray = lab.idslaboratorios 
        ? lab.idslaboratorios.split(',')
        : null;

      const dataExamenes = examenesIdArray  
        ? await Promise.all(examenesIdArray.map(id => labAs400Service.getExamensById(id)))
        : [];

      const dataResponse = {
        id             : lab.id,
        token          : lab.token,
        modalidad      : data.modalidad,
        numeroOrden    : lab.numeroOrden,
        justificacion  : lab.justificacion,
        fechaOrdenOrion: lab.fechaOrdenOrion,
        examenes       : dataExamenes,
      };

      return dataResponse;
    }));

    const dataMap = {
      estudioLab    : idEstudioLab,
      labAs400      : [...labsAs400Map],
      // labAuxiliares : [...labsAuxiliar],
    };

    return dataMap;

  }catch (error) {
    console.error('Error al traer las imagenes de la atencion', error);
    return null;
  }
}


const register = async (idAtencion, dataExamenes) => {

  if(!idAtencion) {
    console.error('id atencion es requerido');
    return null
  }

  if(!dataExamenes || dataExamenes.length === 0) {
    console.error('data examenes es requerido');
    return null
  }


  const query = `
    mutation crearEstudioLaboratorio(
      $laboratorio: String!,
      $atencionMedica: String!,
    ){ 
      crearEstudioLaboratorio(
        laboratorio: $laboratorio
        atencionMedica: $atencionMedica
      ){
        estlab {
          token,id
        }
        status,
        message
      }
    }
  `;

  const variables = {
    laboratorio    : JSON.stringify(dataExamenes),
    atencionMedica : idAtencion,
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;
    const response2 = response.data.data.crearEstudioLaboratorio;
    if (response2.status !== "success") return null;
    return response2.estlab;

  }catch (error) {
    console.error('Error al registrar los examenes', error);
    return null;
  }




}

const update = async (dataExamenes) => {

  if(!dataExamenes || dataExamenes.length === 0) {
    console.error('data examenes es requerido');
    return null
  }


  const query = `
    mutation actualizarEstudioLaboratorioCompleto(
      $laboratorio: String!,
      $idEstLab: ID!,
    ){ 
      actualizarEstudioLaboratorioCompleto(
        laboratorio: $laboratorio
        idEstLab: $idEstLab
      ){
        estlab {
          token,id
        }
        status,
        message
      }
    }
  `;

  let idEstLab = dataExamenes[0].idEstLab

  const variables = {
    laboratorio    : JSON.stringify(dataExamenes),
    idEstLab : idEstLab,
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;
    const response2 = response.data.data.actualizarEstudioLaboratorioCompleto;
    if (response2.status !== "success") return null;
    return response2.estlab;

  }catch (error) {
    console.error('Error al registrar los examenes', error);
    return null;
  }


}

const getHistorialByPaciente = async (idPaciente) => {

  const query = `
    query MyQuery($idPaciente: ID) {
      laboratorioPacienteid(idpaciente: $idPaciente) {
        message
        status
        total
        lab {
          id
          fechaCreacion
          idslaboratorios
          estudiolab {
            consultamedica {
              cita {
                doctor {
                  idPersona {
                    primerNombre
                    primerApellido
                  }
                  especialidad {
                    descripcion
                    id
                  }
                }
                fechaCita
                horaCita
                paciente {
                  persona {
                    primerApellido
                    primerNombre
                  }
                }
              }
            }
          }
        }
      }
    }
  `; 


  const variables = { idPaciente }


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    console.log('response hist lab', response)
    if (response.status !== 200) return null;

    const response2 = response.data.data.laboratorioPacienteid;
    if (response2.status !== "Success") return null;
    const data = response2.lab;
    return data

  }catch(error){
    console.error('Error al obtener el historial de laboratorios', error);
    return null;
  }
}


export const estudioLabService = {
  create,
  getByAtencion,
  getHistorialByPaciente,
  updateNumeroOrden,
  updateById,

  updateMspFiles,
  register,
  update
}


